// 新店铺列表
const newShopList = 'websiteshop/newShop';
// 店铺详情
const shopInfo = 'websiteshop/shopInfo';
export {
  newShopList,
  shopInfo
}